import React from 'react';

import LinkifiedText from '../../../shared/LinkifiedText/LinkifiedText';

import './HomeProcessStageCard.css';

const HomeProcessStageCard = ({ title, leftDesc }) => {
  return (
    <div className='home-process-stage-card-container'>
      <div className='home-process-stage-card-title-container'>
        <h4 className='home-process-stage-card-title'>{title}</h4>
      </div>
      <p className='home-process-stage-card-desc'>
        <LinkifiedText>{leftDesc}</LinkifiedText>
      </p>
    </div>
  );
};

export default HomeProcessStageCard;
